import React from 'react';
import Button from './Button';
import type { ButtonProps } from './Button';

export interface ButtonWithIconProps extends ButtonProps {
  icon: React.ReactNode;
  iconPosition?: 'left' | 'right';
  iconSize?: number | string;
}

const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  icon,
  iconPosition = 'left',
  iconSize = 20,
  children,
  ...buttonProps
}) => {
  const iconElement = React.isValidElement(icon)
    ? React.cloneElement(icon as React.ReactElement<any>, {
        style: {
          fontSize: iconSize,
          width: iconSize,
          height: iconSize,
          ...(icon as React.ReactElement<any>).props?.style,
        },
      })
    : icon;

  return (
    <Button
      {...buttonProps}
      startIcon={iconPosition === 'left' ? iconElement : undefined}
      endIcon={iconPosition === 'right' ? iconElement : undefined}
    >
      {children}
    </Button>
  );
};

export default ButtonWithIcon;
